import instance from "@/request/request";
import BDInstance from "@/request/BDrequest";
// 加载门店信息

// /loadStoreInfo
const loadStoreInfo = (data) => instance.get("/StoreItem/list2",{params:{...data}})

// /loadStoreInfoById
const loadStoreInfoById = (data) => instance.get("/StoreItem/findById",{params:{...data}})

// GetStoreNames
const GetStoreNames = () => instance.get("/Store/getStoreNames")
// /AddStoreItem
const AddStoreItem = (data) => instance.post("/StoreItem/add",data)
// /EditStoreItem
const EditStoreItem = (data) => instance.post("/StoreItem/edit",data)

// StoreItem/buyGoodsAll
const buyGoodsAll = (data) => instance.get("/StoreItem/GetBuyGoodsAll",{params:{...data}})
const GetBuyGoodsOne = (data) => instance.get("/StoreItem/GetBuyGoodsOne",{params:{...data}})

// editBuyGoodsState2
const editBuyGoodsState2 = (data) => instance.put("/StoreItem/editBuyGoodsState2",data)

// getAllStoreAccount
const getAllStoreAccount = (data) => instance.get("/Store/getAllStoreAccount",{params:{...data}})


// /DelStore
const DelStore = (data) => instance.delete("/Store/DelStore",{params:{...data}})

// Antique/AddAntique
const AddAntique = (data) => instance.post("/Antique/AddAntique",data)

// /Antique/GetAntiqueAll
const GetAntiqueAll = (data) => instance.get("/Antique/GetAntiqueAll",{params:{...data}})

// /Antique/login
const AntiqueLogin = (data) => instance.post("/Antique/login",data)

// /Antique/GetAntiqueCollect
const GetAntiqueCollect = (data) => instance.get("/Antique/GetAntiqueCollect",{params:{...data}})

// Antique/AddAntiqueCollect
const AddAntiqueCollect = (data) => instance.post("/Antique/AddAntiqueCollect",data)

// Antique/FindAntiqueById
const FindAntiqueById = (data) => instance.get("/Antique/FindAntiqueById",{params:{...data}})

// Antique/GetCollectById
const GetCollectById = (data) => instance.get("/Antique/GetCollectById",{params:{...data}})

// Antique/EditCollectById
const EditCollectById = (data) => instance.put("/Antique/EditCollectById",data)

// Antique/DelAntiqueCollect
const DelAntiqueCollect = (data) => instance.put("/Antique/DelAntiqueCollect",data)


// Antique/EditAntiqueById
const EditAntiqueById = (data) => instance.put("/Antique/EditAntiqueById",data)

const GetStoreForAntique = (data) => instance.get("/Antique/GetStoreForAntique",{params:{...data}})

// DelAntiqueBindStore
const DelAntiqueBindStore = (data) => instance.put("/Antique/DelAntiqueBindStore",data)

// AddAntiqueBindStore
const AddAntiqueBindStore = (data) => instance.put("/Antique/AddAntiqueBindStore",data)

// GetMyBindStoreById
const GetMyBindStoreById = (data) => instance.get("/Antique/GetMyBindStoreById",{params:{...data}})

// DeleteGoodsPic
const DeleteGoodsPic = (data) => instance.delete("/StoreItem/DeleteGoodsPic",{params:{...data}})

const DelAntique = (data) => instance.delete("/Antique/DelAntique",{params:{...data}})


const GetAllCommunity = (data) => instance.get("/Community/GetAllCommunity",{params:{...data}})

const UpdateCommunityStatus = (data) => instance.post("/Community/UpdateCommunityStatus",data)
// DeleteCommunity
const DeleteCommunity = (data) => instance.delete("/Community/DeleteCommunity",{params:{...data}})

// GetYearStoreStatics
const GetYearStoreStatics = (data) => instance.get("/Finance/GetYearStoreStatics",{params:{...data}})
// GetBillsStatistics
const GetBillsStatistics = (data) => instance.get("/Finance/GetBillsStatistics",{params:{...data}})
// GetTotalStoreStatics
const GetTotalStoreStatics = (data) => instance.get("/Finance/GetTotalStoreStatics",{params:{...data}})
// GetYearStoreStaticsByYear
const GetYearStoreStaticsByYear = (data) => instance.get("/Finance/GetYearStoreStaticsByYear",{params:{...data}})
// /StoreItem/buyGoodsAllToExcel
const buyGoodsAllToExcel = (data) => instance.get("/StoreItem/buyGoodsAllToExcel",{params:{...data},responseType:"blob"})




// buyGoodsToExcelById
const getUserAll = (data) => instance.get("/user/getUserAll",{params:{...data}})

// getUserById
const getUserById = (data) => instance.get("/user/getUserById",{params:{...data}})
// 获取所有团员信息
const getUserTeamByInviteCode = (data) => instance.get("/user/getUserTeamByInviteCode",{params:{...data}})

// 获取所有的标签分类/setting/GetCategoryAll
const GetCategoryAll = (data) => instance.get("/setting/GetCategoryAll",{params:{...data}})

// 获取所有的城市信息/setting/GetCityAll
const GetCityAll = (data) => instance.get("/setting/GetCityAll",{params:{...data}})

// GetCityShowAll
const GetCityShowAll = (data) => instance.get("/setting/GetCityShowAll",{params:{...data}})
// /setting/AddCity
const AddCity = (data) => instance.post("/setting/AddCity",data)

// request.delete(`/setting/DeleteCity/${item.id}`)
const DeleteCity = (data) => instance.delete(`/setting/DeleteCity/${data}`)
const UpdateCity = (data) => instance.put("/setting/UpdateCity",data)

// store/add
const AddStore = (data) => instance.post("/Store/add",data)

// Store/list
const loadStoreList = (data) => instance.get("/Store/list",{params:{...data}})

// getStoreById
const getStoreById = (data) => instance.get("/Store/getStoreById",{params:{...data}})
// delete
const StoreDelte = (data) => instance.delete("/Store/delete",{params:{...data}})

// /Store/deleteCarousel
const StoreDelteCarousel = (data) => instance.delete("/Store/deleteCarousel",{params:{...data}})

// addCarousel
const AddCarousel = (data) => instance.post("/Store/addCarousel",data)

// /editStoreById
const editStoreById = (data) => instance.put("/Store/editStoreById",data)

// uploadUserById
const uploadUserById = (data) => instance.put("/user/uploadUserById",data)

// 上架商品/goods/add
const GoodsAdd = (data) => instance.post("/goods/add",data)
const SeckillGoodsAdd = (data) => instance.post("/seckill/add",data)
const batEditGoods = (data) => instance.put("/goods/batEditGoods",data)

// 地图服务
// SearchStore
const SearchStore = (data) => instance.get("/SearchStore",{params:{...data}})

// goods/list
const GetGoodList = (data) => instance.get("/goods/list",{params:{...data}})
const GetSeckillGoodList = (data) => instance.get("/seckill/list",{params:{...data}})

// goods/copy
const CopyGoodsById = (data) => instance.post("/goods/copyGoods/" + data)


// goods/getGoodsById
const getGoodsById = (data) => instance.get("/goods/getGoodsById",{params:{...data}})
const SeckillGetGoodsById = (data) => instance.get("/seckill/getGoodsById",{params:{...data}})


// /goods/addGoodsImages
const AddGoodsImages = (data) => instance.post("/goods/addGoodsImages",data)
const AddSeckillGoodsImages = (data) => instance.post("/seckill/addSeckillGoodsImages",data)

// goods/deleteGoodsImages
const deleteGoodsImages = (data) => instance.delete("/goods/deleteGoodsImages",{params:{...data}})
const deleteSeckillGoodsImages = (data) => instance.delete("/seckill/deleteSeckillGoodsImages",{params:{...data}})

// /goods/editGoods
const editGoods = (data) => instance.put("/goods/editGoods",data)
const seckillEditGoods = (data) => instance.put("/seckill/editGoods",data)

// 系统设置/admin/setting/GetSettingAll
const GetSettingAll = (data) => instance.get("/setting/GetSettingAll",{params:{...data}})
// UpdateSetting
const UpdateSetting = (data) => instance.put("/setting/UpdateSetting",data)

// getBillsList/orderBills
const getBillsList = (data) => instance.get("/orderBills/getBillsList",{params:{...data}})
const getseckillOrderList = (data) => instance.get("/seckillOrder/getBillsList",{params:{...data}})
// getBillsByTradeNo
const getBillsByTradeNo = (data) => instance.get("/orderBills/getBillsByTradeNo",{params:{...data}})
const getSeckillBillsByTradeNo = (data) => instance.get("/seckillOrder/getBillsByTradeNo",{params:{...data}})

// editOrderBill
const editOrderBill = (data) => instance.put("/orderBills/editOrderBill",data)
const editSeckillOrderBill = (data) => instance.put("/seckillOrder/editOrderBill",data)

// getDistributionData
const getDistributionData = (data) => instance.get("/getDistributionData",{params:{...data}})

// 删除商品
// goods/deleteGoods
const DelGoods = (data) => instance.delete("/goods/deleteGoods",{params:{...data}})
const seckillDelGoods = (data) => instance.delete("/seckill/deleteGoods",{params:{...data}})
const deleteGoodsBindStoreById = (data) => instance.put("/seckill/deleteGoodsBindStoreById",data)
const addGoodsBindStoreById = (data) => instance.put("/seckill/addGoodsBindStoreById",data)

// /Store/getApplyList
const getApplyList = (data) => instance.get("/Store/getApplyList",{params:{...data}})

// /Store/ExecuteApply
const ExecuteApply = (data) => instance.put("/Store/ExecuteApply",data)

// /BackPerson/list
const GetBackPersonList = (data) => instance.get("/BackPerson/list",{params:{...data}})
const getUserList = (data) => instance.get("/BackPerson/getUserList",{params:{...data}})

// /BackPerson/getOne/{id}
const GetBackPersonById = (data) => instance.get("/BackPerson/getOne/" + data.id)

// /BackPerson/getRoleLabels
// 根据传入的数据，调用instance.get方法，获取角色标签
const getRoleLabels = (data) => instance.get("/BackPerson/getRoleLabels",{params:{...data}})
const backPersonAdd = (data) => instance.post("/BackPerson/add",data)

// 
const backPersonUpdate = (data) => instance.put("/BackPerson/update",data)

const backPersonDel = (data) => instance.delete("/BackPerson/delete",{params:{...data}})

// /BackPerson/getCityManagers
const getCityManagers = () => instance.get("/BackPerson/getCityManagers")

// 退款
const RefundApplication = (data) => instance.post("/refund",data)
const RefundSQBApplication = (data) => instance.post("/sqb/refund",data)
const SeckillRefundApplication = (data) => instance.post("/seckill/refund",data)

// /setting/addAdvertisement
const addAdvertisement = (data) => instance.post("/setting/Advertisement/add",data)

// /addAdvertisement/list
const AdvertisementList = (data) => instance.get("/setting/Advertisement/list",{params:{...data}})

// /getUserCanRefundPermit
const getUserCanRefundPermit = (data) => instance.get("/getUserCanRefundPermit",{params:{...data}})

// /Advertisement/detail
const advertisementDetail = (data) => instance.get("/setting/Advertisement/detail",{params:{...data}})

// /Advertisement/edit
const UpdateAdvertisement = (data) => instance.put("/setting/Advertisement/edit",data)

// /Advertisement/delete
const DeleteAdvertisement = (data) => instance.delete("/setting/Advertisement/delete",{params:{...data}})

// /setting/exportBillsByIds
const exportBillsByIds = (data) => instance.get("/setting/export/BillsByIds",{params:{...data}})
const exportSeckillBillsByIds = (data) => instance.get("/setting/export/seckill/BillsByIds",{params:{...data}})


// /setting/exportBillsAll
const exportBillsAll = (data) => instance.get("/setting/export/BillsAll",{params:{...data}})
const exportSeckillBillsAll = (data) => instance.get("/setting/export/seckill/BillsAll",{params:{...data}})

// /finance/getFinanceDataByMonth
const getFinanceDataByMonth = (data) => instance.get("/finance/getFinanceDataByMonth",{params:{...data}})

// /finance/getFinanceDataByYears
const getFinanceDataByYears = (data) => instance.get("/finance/getFinanceDataByYears",{params:{...data}})

// /finance/export/StoreFinanceDate
const StoreFinanceData = (data) => instance.get("/finance/export/StoreFinanceData",{params:{...data},responseType:"blob"})

// /finance/getFinanceOrderList
const getFinanceOrderList = (data) => instance.get("/finance/getFinanceOrderList",{params:{...data}})

// /finance/getFinanceStoreList
const getFinanceStoreList = (data) => instance.get("/finance/getFinanceStoreList",{params:{...data}})

// /finance/getFinanceStoreSummary
const getFinanceStoreSummary = (data) => instance.get("/finance/getFinanceStoreSummary",{params:{...data}})

// /distribution/export/getUserDistributionByDate
const exportUserDistributionByDate = (data) => instance.post("/distribution/export/getUserDistributionByDate",data)

// /admin/Permit/getPermitList
const getRole = (data) => instance.get("/Permit/getRole",{params:{...data}})
// addRole
const addRole = (data) => instance.post("/Permit/addRole",data)

// editRole
const putRole = (data) => instance.put("/Permit/editRole",data)

// delRole
const delRole = (data) => instance.delete("/Permit/delRole",{params:{...data}})

// getPermitList
const getPermitList = (data) => instance.get("/Permit/getPermitList",{params:{...data}})

// Permit/getRolePermit
const getRolePermitById = (data) => instance.get("/Permit/getRolePermitById",{params:{...data}})

// setRolePermit
const setRolePermit = (data) => instance.put("/Permit/setRolePermit",data)

// getCurrentUserPermits
const getCurrentUserPermits = () => instance.get("/Permit/getCurrentUserPermits")

// getCaptcha
const getCaptcha = () => instance.get("/getCaptcha");

// /BD/createUser
const createDBUser = (data) => instance.post("/BD/createUser",data)

// /BD/getUserList
const getBDUserList = (data) => instance.get("/BD/getUserList",{params:{...data}})

// /BD/getUserByUid
const getBDUserByUid = (data) => instance.get("/BD/getUserByUid",{params:{...data}})

// updateUser
const updateBDUser = (data) => instance.put("/BD/updateUser",data)

// deleteUser
const deleteBDUser = (data) => instance.delete("/BD/deleteUser",{params:{...data}})

// /BD/getBDStoreList
const getBDStoreList = (data) => instance.get("/BD/getBDStoreList",{params:{...data}})

const getBDApplicationStoreById = (data) => BDInstance.get("/BDStore/getStoreById",{params:{...data}})

const GetBDStoreById = (data) => BDInstance.get("/BDStore/getStoreById",{params:{...data}})

// /BD/SetBDStoreApplicationVerify
const SetBDStoreApplicationVerify = (data) => instance.post("/BD/SetBDStoreApplicationVerify",data)


/**
 * 获取店铺名称列表
 * @param {Object} data - 请求参数对象
 * @returns {Promise} - 返回一个Promise对象，包含店铺名称列表数据
 */
const getStoreNamesList = (data) => instance.get("/Store/StoreNamesList",{params:{...data}})

/**
 * 根据ID获取BD商品信息的函数
 * @param {Object} data - 包含商品ID的参数对象
 * @returns {Promise} - 返回一个Promise对象，包含请求的结果
 */
const getBDGoodsById = (data) => BDInstance.get("/BDGoods/getGoodsById",{params:{...data}})
/**
 * 获取BD商品列表
 * @param {Object} data - 请求参数对象
 * @returns {Promise} - 返回一个Promise对象，用于获取商品列表数据
 */
const getBDGoodList = (data) => instance.get("/BD/getGoodList",{params:{...data}})


// /BD/SetBDGoodApplicationVerify
/**
 * 设置BD商品申请审核状态的接口函数
 * @param {Object} data - 请求数据对象，包含审核相关信息
 * @returns {Promise} - 返回一个Promise对象，用于处理接口请求的响应结果
 */
const SetBDGoodApplicationVerify = (data) => instance.post("/BD/SetBDGoodApplicationVerify",data)
/**
 * 对数据进行BD转换的函数
 * @param {Object} data - 需要进行转换的数据对象
 * @returns {Promise} 返回一个Promise对象，包含转换后的数据
 */
const BDTransformData = (data) => instance.post("/BD/transformData",data)


// externalCode/list
/**
 * 获取外部核销码列表
 * @param {Object} data - 请求参数对象
 * @returns {Promise} - 返回一个Promise对象，包含外部代码列表数据
 */
const getExternalCodeList = (data) => instance.get("/externalCode/list",{params:{...data}})  // 使用axios实例发送GET请求，传入URL和参数


// externalCode/getExternalGoodsList
const getExternalGoodsList = (data) => instance.get("/externalCode/getExternalGoodsList",{params:{...data}})
const getExternalCountById = (data) => instance.get("/externalCode/getExternalCountById",{params:{...data}})

// /expireExternalCodeByGoodsId
const expireExternalCodeByGoodsId = (data) => instance.post("/externalCode/expireExternalCodeByGoodsId",data)


const deleteExternal = (data) => instance.delete("/externalCode/deleteExternal",{params:{...data}}) 
// externalCode/add
const addExternalCodeFun = (data) => instance.post("/externalCode/add",data)

const cutGoodsToLowerPriceApi = (data) => instance.post("/goods/cutGoodsToLowerPrice",data)

// Relation/add
const addRelationAccount = (data) => instance.post("/Relation/add",data)

// /getList
const getRelationList = (data) => instance.get("/Relation/getList",{params:{...data}})


// getUserById/
const getRaltionUserById = (data) => instance.get("/Relation/getUserById/" + data)

// updateUser
const RelationUpdateUser = (data) => instance.put("/Relation/updateUser",data)

// Relation/deleteUser
const deleteRelationUser = (data) => instance.delete("/Relation/deleteUser/" + data)
// /Relation/getStoreListRelation
const getStoreListRelation = (data) => instance.get("/Relation/getStoreListRelation",{params:{...data}})

// BindStore
const bindStore = (data) => instance.post("/Relation/bindStore",data)

// /unBind
const unBindStore = (data) => instance.post("/Relation/unBindStore",data)

// /admin/orderBills/getTransferLogList
const getTransferLogList = (data) => instance.get("/orderBills/getTransferLogList",{params:{...data}})

// /distribution/getDistributionList
const getDistributionList = (data) => instance.get("/distribution/getDistributionList",{params:{...data}})


export {
    getUserList,
    batEditGoods,
    CopyGoodsById,
    deleteExternal,
    addGoodsBindStoreById,
    deleteGoodsBindStoreById,
    exportSeckillBillsAll,
    exportSeckillBillsByIds,
    editSeckillOrderBill,
    getSeckillBillsByTradeNo,
    SeckillRefundApplication,
    getExternalCountById,
    expireExternalCodeByGoodsId,
    getseckillOrderList,
    seckillDelGoods,
    seckillEditGoods,
    SeckillGetGoodsById,
    GetSeckillGoodList,
    SeckillGoodsAdd,
    deleteSeckillGoodsImages,
    AddSeckillGoodsImages,
    getTransferLogList,
    getDistributionList,
    unBindStore,
    getUserTeamByInviteCode,
    bindStore,
    getStoreListRelation,
    deleteRelationUser,
    RelationUpdateUser,
    getRaltionUserById,
    getRelationList,
    addRelationAccount,
    BDTransformData,
    cutGoodsToLowerPriceApi,
    addExternalCodeFun,
    getExternalGoodsList,
    getExternalCodeList,
    SetBDGoodApplicationVerify,
    getBDGoodsById,
    getBDGoodList,
    getStoreNamesList,
    SetBDStoreApplicationVerify,
    GetBDStoreById,
    getBDApplicationStoreById,
    getBDStoreList,
    deleteBDUser,
    updateBDUser,
    getBDUserByUid,
    getBDUserList,
    createDBUser,
    getCaptcha,
    setRolePermit,
    getRolePermitById,
    getPermitList,
    getCurrentUserPermits,
    putRole,
    delRole,
    addRole,
    getRole,
    exportUserDistributionByDate,
    StoreFinanceData,
    getFinanceOrderList,
    getFinanceStoreList,
    getFinanceStoreSummary,
    getFinanceDataByYears,
    getFinanceDataByMonth,
    exportBillsAll,
    exportBillsByIds,
    DeleteAdvertisement,
    UpdateAdvertisement,
    advertisementDetail,
    getUserCanRefundPermit,
    AdvertisementList,
    UpdateCity,
    DeleteCity,
    AddCity,
    addAdvertisement,
    RefundApplication,
    backPersonDel,
    getCityManagers,
    backPersonUpdate,
    backPersonAdd,
    getRoleLabels,
    GetBackPersonById,
    GetBackPersonList,
    getApplyList,
    ExecuteApply,
    getDistributionData,
    DelGoods,
    editOrderBill,
    getBillsList,
    getBillsByTradeNo,
    GetSettingAll,
    UpdateSetting,
getUserAll,
GetCityAll,
GetCategoryAll,
RefundSQBApplication,
AddStore,
loadStoreList,
getStoreById,
StoreDelte,
StoreDelteCarousel,
AddCarousel,
    editStoreById,
    getUserById,
    uploadUserById,
    GoodsAdd,
    SearchStore,
    GetGoodList,
    getGoodsById,
    AddGoodsImages,
    deleteGoodsImages,
    editGoods,
    GetCityShowAll,



    GetBuyGoodsOne,
    buyGoodsAllToExcel,
    GetYearStoreStatics,
    GetBillsStatistics,
    GetTotalStoreStatics,
    GetYearStoreStaticsByYear,

    GetAllCommunity,
    UpdateCommunityStatus,
    DeleteCommunity,

    DelAntique,
    DeleteGoodsPic,

    AddAntiqueBindStore,
    DelAntiqueBindStore,
    GetMyBindStoreById,

    GetStoreForAntique,
    EditAntiqueById,
    DelAntiqueCollect,
    EditCollectById,
    GetCollectById,
    FindAntiqueById,
    AddAntiqueCollect,
    GetAntiqueCollect,
    AntiqueLogin,
    AddAntique,
    GetAntiqueAll,

    DelStore,
    getAllStoreAccount,
    buyGoodsAll,
    editBuyGoodsState2,
    loadStoreInfo,
    loadStoreInfoById,
    GetStoreNames,
    AddStoreItem,
    EditStoreItem
}